import React, { useContext } from "react";

// Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// components
import AddClassPropertyModalAdvancedSettingsContent from "./AddClassPropertyModalAdvancedSettingsContent";

// Global state
import { StateContext } from "../../AppStateContext";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    background: "transparent",
    boxShadow: "none",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: "200",
    fontFamily: "Alegreya Sans, sans-serif",
    background: "transparent",
    color: "#fff",
  },
  accordion: {
    background: "transparent",
    boxShadow: "none",
  },
}));

const AddClassPropertyModalAdvancedSettings = ({ propObj, setPropObj }) => {
  // Material UI styling
  const classes = useStyles();

  // Consume global state
  const state = useContext(StateContext);

  return (
    <div className={classes.root}>
      <Accordion className={classes.accordion}>
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon
              style={{ color: state.theme === "dark" ? "#e2e9ff" : "#00152b" }}
            />
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography
            className={classes.heading}
            style={{ color: state.theme === "dark" ? "#e2e9ff" : "#00152b" }}
            id="addPropertyAdvancedSettingsButton"
          >
            Advanced Settings
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AddClassPropertyModalAdvancedSettingsContent
            propObj={propObj}
            setPropObj={setPropObj}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default AddClassPropertyModalAdvancedSettings;
